/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Ethnicity {
    ASIAN = 'ASIAN',
    BLACK_AFRICAN_DESCENT = 'BLACK_AFRICAN_DESCENT',
    LATIN_HISPANIC = 'LATIN_HISPANIC',
    MIDDLE_EASTERN = 'MIDDLE_EASTERN',
    MIXED = 'MIXED',
    SOUTH_ASIAN = 'SOUTH_ASIAN',
    WHITE = 'WHITE',
    OTHER = 'OTHER',
}
